module.exports = __webpack_public_path__ + "img/1.-季节观赏法-春季-西府海棠（袁方-摄）.1d4237cc.jpg";